export const isInSalesForce = () => {
  return Boolean(window.wrBox)
}
